<script setup lang="ts">
import { computed } from 'vue';
import { PredefinedOptionKind, PredefinedOptionType, SystemEvent } from '@/library/message/enum';
import type { BaseSystemMessage, PredictiveSuggestionSelectionEvent } from '@/library/message/types';
import { useI18n } from '@/plugins/i18n';

import ChatMessageWrapper from './ChatMessageWrapper.vue';
import MessageActions from '../MessageActions.vue';
import type { ActionItem } from '../MessageActions.vue';

// TODO: refactor it to resolution message, update handler
export interface PreSupportPredictionMessageProps {
  // TODO: fix type, create message type if needed
  message: BaseSystemMessage & { selectedOption: PredefinedOptionKind };
  /**
   * The previous message/notice in the stack.
   */
  previous?: unknown;
  /**
   * The next message/notice in the stack.
   */
  next?: unknown;
}

const props = defineProps<PreSupportPredictionMessageProps>();
const emit = defineEmits<{
  (e: 'message:input', event: PredictiveSuggestionSelectionEvent): void;
}>();

const { t } = useI18n();

const actionItems = computed<ActionItem[]>(() => {
  return [
    {
      id: PredefinedOptionType.CONNECT_TO_SUPPORT,
      label: `${t('global.yes')}, ${t('chat.sys.msg.pre_support_prompt.need_more_help')}`,
      icon: 'MdThumbupalt',
      selected: props.message.selectedOption === PredefinedOptionType.CONNECT_TO_SUPPORT,
    },
    {
      id: PredefinedOptionType.NO_OTHER_ISSUE,
      label: `${t('global.no')}, Other issue`,
      icon: 'MdSupportagent',
      selected: props.message.selectedOption === PredefinedOptionType.NO_OTHER_ISSUE,
    },
  ];
});

const buildEvent = (item: ActionItem) => {
  const event: PredictiveSuggestionSelectionEvent = {
    type: SystemEvent.PREDICTIVE_SUGGESTION_SELECTION,
    message: props.message,
    payload: {
      selected: item.id as typeof PredefinedOptionType.CONNECT_TO_SUPPORT | typeof PredefinedOptionType.NO_OTHER_ISSUE,
    },
  };

  emit('message:input', event);
};
</script>

<template>
  <ChatMessageWrapper :previous="previous" :next="next" :message="message">
    <template #actions>
      <MessageActions :items="actionItems" @select="buildEvent" />
    </template>
  </ChatMessageWrapper>
</template>
